import { useQueryClientUtils } from '../../useQueryClientUtils'
import { useFetchDocumentTermsAndConditions } from './useFetchDocumentTermsAndConditions'
import { queryKeys as documentQueryKeys, type QueryDocumentByIdCacheData } from '../useQueryDocument'

const update = () => {
  const { update } = useFetchDocumentTermsAndConditions()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: update,
    onMutate: (variables) => {
      queryClient.cancelQueries({
        queryKey: documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      })
      cancelQueries([
        documentQueryKeys.all._def,
        documentQueryKeys.allInfinite._def,
      ])
    },
    onError: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      })
    },
    onSettled: () => {
      invalidateQueries([
        documentQueryKeys.all._def,
        documentQueryKeys.allInfinite._def,
      ])
    },
    onSuccess: (responseData, variables) => {
      queryClient.setQueriesData<QueryDocumentByIdCacheData>({
        queryKey: documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      }, (oldData) => {
        if (!oldData)
          return oldData

        const updated = {
          ...oldData,
          data: {
            ...oldData.data,
            terms_and_conditions: responseData.data,
          },
        }

        return updated
      }, {
        updatedAt: Date.now(),
      })
    },
  })
}

export const useMutationDocumentTermsAndConditions = ({
  update,
})
